import secondaryComponents from "../..";
import Images from "../../../../assets/images";
import { RoutedModal } from "../../../common";
import { BusinessAccountForm } from "../BusinessAccountForm";
import { DeleteBusinessAccountTable } from "../DeleteBusinessAccountTable";
import { useBusinessAccountTable } from "./useBusinessAccountTable";

export const BusinessAccountTable = ({
  connectionList,
  //   metaDetails = {},
  //   gotoPage = () => {},
}) => {
  const {
    instance,
    accountDetails,
    deleteAccountDetails,
    setDeleteAccountDetails,
    setAccountDetails,
  } = useBusinessAccountTable({
    connectionList,
  });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <div className="text-center my-5">
          <img
            width="250px"
            height="262px"
            src={Images.tnxEmptyState}
            alt="empty state"
          />
          <h4 className="font-weight-semibold text-center mt-4">
            No Business Connection found
          </h4>
          <p className="text-center">
            Use the button above to create a new connection. When you do, they
            would appear here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      <RoutedModal
        isActive={!!accountDetails}
        width={600}
        headerTitle="Update Account Connection"
        closeModal={() => setAccountDetails(false)}
        style={{ height: "auto" }}
      >
        <BusinessAccountForm
          isEditMode={true}
          accountInfo={accountDetails}
          closeModal={() => setAccountDetails(false)}
        />
      </RoutedModal>

      <secondaryComponents.Modal
        isActive={deleteAccountDetails !== null}
        width={500}
        closeModal={() => setDeleteAccountDetails(null)}
      >
        <DeleteBusinessAccountTable
          businessAccountDetails={deleteAccountDetails}
          closeModal={() => setDeleteAccountDetails(null)}
        />
      </secondaryComponents.Modal>
    </>
  );
};
